import MentoringFooterItem from './MentoringFooterItem.vue';
import { Child } from './types';

export { Child };
export default MentoringFooterItem;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/teamcard/components/item/index.ts